angular.module('supersearch', ['ngResource', 'ngRoute']).config(['$routeProvider', function ($routeProvider) {
  $routeProvider.when(CONFIG.url.supersearch.list(), {
    controller: 'SearchCtrl',
    templateUrl: '/r/static/templates/supersearch/list.html',
  })
}])

angular
  .module('supersearch')
  .controller(
    'SearchCtrl',
    ['$scope', '$location', '$rootScope', '$timeout', '$routeParams', 'Member', 'Invoice', 'Announcement', 'Updreq', function ($scope, $location, $rootScope, $timeout, $routeParams, Member, Invoice, Announcement, Updreq) {
      var is_box_search,
        timer,
        search_progress = 0

      $scope.members_count = $scope.announcements_count = $scope.invoices_count = $scope.updreqs_count = 0

      if ($routeParams.term) {
        is_box_search = false
        $scope.utils.setPageID('default')
      } else {
        is_box_search = true
      }

      if ($routeParams.type) {
        $scope.viewStatus = $routeParams.type
      }

      // If this is the full page search,
      if (!is_box_search) {
        a4.loaded($scope)
        do_search($routeParams.term)
      }

      $scope.show_box = false

      $scope.$watch(
        'box_term',
        function () {
          if ($scope.box_term && $scope.box_term.length > 2) {
            var current_term = $scope.box_term
            $timeout.cancel(timer)
            timer = $timeout(function () {
              do_search(current_term)
            }, 500)
          } else {
            $scope.show_box = false
          }
        },
        true,
      )

      // Keep track of the result counters
      $scope.total_count = 0

      function updateTotals(amount) {
        $scope.total_count += amount
      }

      $scope.$watch('total_count', function () {
        // Show the box if we have any results
        if ($scope.total_count > 0) {
          $scope.show_box = true
        } else {
          //$scope.members = null;
          $scope.show_box = false
        }
      })

      // Detect clicks in the document and hide the supersearch box
      $('html').on('click', function (e) {
        $scope.$apply(function () {
          $scope.show_box = false
        })
      })

      // ... Unless we clicked inside the box itself or search input
      $('html').on('click', '#supersearch-box,#supersearch .input-group', function (e) {
        e.stopPropagation()
      })

      $scope.finishedSearching = function () {
        return search_progress === 0
      }

      // Near duplicate from announcements controller
      $scope.setViewStatus = function (viewStatus) {
        $scope.viewStatus = viewStatus
      }

      $scope.seeMore = function (context) {
        $scope.show_box = false
        $location.path(CONFIG.url.supersearch.list(context, $scope.box_term))
      }

      $scope.seeDetail = function (path) {
        $scope.show_box = false
        $location.path(path)
      }

      $scope.showBox = function () {
        if ($scope.box_term && $scope.box_term.length > 2) {
          $scope.show_box = true
        }
      }

      $scope.focusBox = function () {
        $scope.show_box = true
        $('#supersearch input')[0].focus()
      }

      $scope.highlightTerm = function (text) {
        $scope.term_re = new RegExp($scope.box_term, 'gi')
        var matches = $scope.term_re.exec(text)
        if (matches && matches[0]) {
          var ret = text.replace($scope.term_re, '<b>' + matches[0] + '</b>')
          return ret
        }
        return text
      }

      function do_search(term) {
        search_progress = 5

        var resources = {
          announcements: Announcement,
          invoices: Invoice,
          updreqs: Updreq,
        }

        // Member quicksearch
        Member.quicksearch(
          {term: term},
          function (members) {
            $scope.members = {}

            $.each(members.results, function (i, m) {
              $scope.members[m.id] = m
            })
            $scope.members_count = members.results.length
            $scope.members_total = $scope.members_count
            search_progress--

            // Once we get quicksearch results back, then do the full search
            Member.supersearch(
              {
                term: term,
                show_all: !is_box_search,
              },
              function (data) {
                search_progress--

                if (is_box_search) {
                  $scope.members_total = data.results.length
                  while ($scope.members_count < 3 && data.results.length > 0) {
                    var m = data.results.pop()
                    if (!$scope.members[m.id]) {
                      $scope.members[m.id] = m
                      $scope.members_count++
                    }
                  }
                } else {
                  $.each(data.results, function (i, m) {
                    if (!$scope.members[m.id]) {
                      $scope.members[m.id] = m
                      $scope.members_count++
                    }
                  })
                }

                updateTotals($scope.members_count)
              },
              a4.restErrorFactory($scope),
            )
          },
          a4.restErrorFactory($scope),
        )

        // All the other supersearches
        $.each(resources, function (name, value) {
          value.supersearch(
            {
              term: term,
              show_all: !is_box_search,
            },
            // success handler
            function (data) {
              $scope[name] = data.results
              $scope[name + '_count'] = data.results.length
              updateTotals($scope[name + '_count'])
              search_progress--
            },
            // error handler
            a4.restErrorFactory($scope),
          )
        })
      }
    }],
  )
